import { getElementTag } from '@nrk/dh-server-libs/get-element-tag'
import { createTracker } from '@nrk/dh-snowplow'
import { EventSchema, ViewportEventKind } from '@nrk/snowplow-web'
import './client.css'

const tag = getElementTag(__APP_NAME__, __APP_VERSION__)

function safeDefine(elementName, constructor) {
  if (typeof customElements.get(elementName) === 'undefined') {
    customElements.define(elementName, constructor)
  }
}

class AppElement extends HTMLElement {
  name = tag
  #tracker
  #entryObserver
  #exitObserver

  connectedCallback() {
    this.#defineCustomElements()
    this.#createTracker()

    this.#startViewportLogger()
    this.addEventListener('dh-basis-sveip-active-changed', this.#handleActiveChanged)
  }

  disconnectedCallback() {
    this.#stopViewportLogger()
    this.removeEventListener('dh-basis-sveip-active-changed', this.#handleActiveChanged)
  }

  #defineCustomElements() {
    safeDefine('dh-infosveip', require('./components/infosveip.ts').default)
  }

  #createTracker() {
    if (window.preventTracking) {
      return
    }

    if (process.env.DEV) {
      import('@nrk/dh-snowplow/mock').then(({ mock }) => mock()).catch(console.error)
    }

    this.#tracker = createTracker('dh-infosveip', {
      environment: process.env.ENVIRONMENT,
      contentContext: {
        source: 'pp',
        id: this.dataset.selfId,
      },
    })
  }

  #handleActiveChanged = (e) => {
    this.#tracker?.trackSelfDescribingEvent({
      schema: EventSchema.StepEvent,
      data: {
        current: e.detail.nextIndex + 1,
        total: this.#scrollContainerChildren.length,
      },
    })
  }

  #startViewportLogger() {
    if (window.preventTracking) {
      return
    }

    this.#entryObserver = new IntersectionObserver((entries) => {
      if (!entries[0]?.isIntersecting) {
        return
      }
      this.#entryObserver?.disconnect()
      this.#exitObserver?.observe(this)
      this.#tracker?.trackSelfDescribingEvent({
        schema: EventSchema.ViewportEvent,
        data: {
          kind: ViewportEventKind.Entry,
        },
      })
    }, {})

    this.#exitObserver = new IntersectionObserver(
      (entries) => {
        if (!entries[0]?.isIntersecting) {
          return
        }
        this.#exitObserver?.disconnect()
        this.#tracker?.trackSelfDescribingEvent({
          schema: EventSchema.ViewportEvent,
          data: {
            kind: ViewportEventKind.Exit,
          },
        })
      },
      { threshold: [1], rootMargin: '3000px 0px -100% 0px' },
    )

    this.#entryObserver.observe(this)
  }

  #stopViewportLogger() {
    this.#entryObserver?.disconnect()
    this.#exitObserver?.disconnect()
  }

  get #scrollContainerChildren() {
    return this.querySelectorAll(`[data-scroll-container] > *`)
  }
}

if (!customElements.get(tag)) {
  customElements.define(tag, AppElement)
}
